import { applyMiddleware, combineReducers, createStore, compose } from 'redux'
import { ISessionState, reducer as sessionReducer } from '../session'
import { DrawerState, reducer as drawerReducer } from './drawer'
import LogRocket from 'logrocket'

// Define the store interface first to avoid circular references
export interface IStoreState {
  session: ISessionState
  drawer: DrawerState
}

// Create root reducer with typechecking
const rootReducer = combineReducers({
  session: sessionReducer,
  drawer: drawerReducer,
})

// Setup enhancers
const composeEnhancers =
  typeof window !== 'undefined' &&
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose

// Create middleware
const middleware = applyMiddleware(LogRocket.reduxMiddleware())

// Create store with defensive coding
const store = createStore(rootReducer, composeEnhancers(middleware))

// Add debugging for initial state
if (process.env.NODE_ENV !== 'production') {
  console.log('Initial Redux State:', {
    session: {
      ...store.getState().session,
      // Don't log tokens in console
      accessToken: store.getState().session.accessToken
        ? '[PRESENT]'
        : '[NONE]',
      refreshToken: store.getState().session.refreshToken
        ? '[PRESENT]'
        : '[NONE]',
    },
    drawer: store.getState().drawer,
  })
}

export default store
